"use client";

import _createForOfIteratorHelper from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { isBackdrop } from "./63XF7ACK.js";
import { walkTreeOutside } from "./AOUGVQZ3.js";
import { setProperty } from "./K2ZF5NU7.js"; // src/dialog/utils/mark-tree-outside.ts

import { chain } from "@ariakit/core/utils/misc";

function getPropertyName() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var ancestor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return "__ariakit-dialog-".concat(ancestor ? "ancestor" : "outside").concat(id ? "-".concat(id) : "");
}

function markElement(element) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return chain(setProperty(element, getPropertyName(), true), setProperty(element, getPropertyName(id), true));
}

function markAncestor(element) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return chain(setProperty(element, getPropertyName("", true), true), setProperty(element, getPropertyName(id, true), true));
}

function isElementMarked(element, id) {
  var ancestorProperty = getPropertyName(id, true);
  if (element[ancestorProperty]) return true;
  var elementProperty = getPropertyName(id);

  do {
    if (element[elementProperty]) return true;
    if (!element.parentElement) return false;
    element = element.parentElement;
  } while (true);
}

function markTreeOutside(id, elements) {
  var cleanups = [];
  var ids = elements.map(function (el) {
    return el == null ? void 0 : el.id;
  });
  walkTreeOutside(id, elements, function (element) {
    if (isBackdrop.apply(void 0, [element].concat(_toConsumableArray(ids)))) return;
    cleanups.unshift(markElement(element, id));
  }, function (ancestor, element) {
    var isAnotherDialogAncestor = element.hasAttribute("data-dialog") && element.id !== id;
    if (isAnotherDialogAncestor) return;
    cleanups.unshift(markAncestor(ancestor, id));
  });

  var restoreAccessibilityTree = function restoreAccessibilityTree() {
    var _iterator = _createForOfIteratorHelper(cleanups),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cleanup = _step.value;
        cleanup();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  return restoreAccessibilityTree;
}

export { markElement, markAncestor, isElementMarked, markTreeOutside };